import { Search } from '@/DTOS/Contract/Search';
import request from '../../utils/request';

const ContractService = {
  search: (search: Search) => {
    return request('/contract/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      companyId: any;
      accountSaleId: any;
      enumContractStatusId: number;
      offerId?: any;
      number: any;
      date: any;
      dateStart: any;
      dateEnd: any;
      datePeriod?: any;
      acquisitionType: any;
      isExpedite: boolean;
      intervention: number;
      hasAutomaticExtension: boolean;
      hasUnlimitedInterventions: boolean;
      registrationNumber: any;
      remarks: any;
      contractInterventionSetting: any;
      contractWorkPlaceItems?: any;
      contractLaborExtras?: any;
    }
  ) => {
    return request('/contract/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          accountSaleId: formData.accountSaleId,
          companyId: formData.companyId,
          enumContractStatusId: formData.enumContractStatusId,
          offerId: formData.offerId,
          number: formData.number,
          date: formData.date,
          dateStart: formData.dateStart,
          dateEnd: formData.dateEnd,
          datePeriod: formData.datePeriod,
          acquisitionType: formData.acquisitionType,
          isExpedite: formData.isExpedite,
          intervention: formData.intervention,
          hasAutomaticExtension: formData.hasAutomaticExtension,
          hasUnlimitedInterventions: formData.hasUnlimitedInterventions,
          registrationNumber: formData.registrationNumber,
          remarks: formData.remarks,
          contractInterventionSetting: formData.contractInterventionSetting,
          contractWorkPlaceItems: formData.contractWorkPlaceItems,
          contractLaborExtras: formData.contractLaborExtras,
        },
      }),
    });
  },

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/contract/uploadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ id: any) => {
    return request(
      '/contract/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: id }),
      },
      true
    );
  },

  downloadAdditionalFile: (/** @type {any} */ id: any) => {
    return request(
      '/contract/downloadAdditionalFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: id }),
      },
      true
    );
  },

  print: (search: Search) => {
    return request(
      '/contract/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },

  updateAllContract: () => {
    return request(
      '/contract/genereazaPlanificareData',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
      },
      true
    );
  },

  getContractUpdates: (contractId: string) => {
    return request('/contract/getContractUpdates', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ request: contractId }),
    });
  },

  copy: (id: string) => {
    return request('/contract/copy', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ request: id }),
    });
  },
};

export default ContractService;
